import { Box, Container, Divider, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import CDMO from "./CDMO";
import Brand from "./Brand";
import InvitationSentScreen from "./InvitationSentScreen";
import Profile from "./Profile";
export default function InviteTeamMember({
  setInviteDrawer,
  departmentDetails,
  handleRefresh,
}) {
  const [showComponent, setShowComponent] = React.useState("Profile");
  const [profileData, setProfileData] = React.useState({
    name: "",
    email: "",
    phoneCode: "",
    phoneNumber: "",
    country: "",
    location: "",
    employeeNumber: "",
    role: "",
    departmentID: null,
    collaborator_role_id: null,
    collaboratorRoleName: "",
    collaborator_type_id: null,
  });
  
  const [brandData, setBrandData] = React.useState({ brands: "", products: "" });
  
  // Track previous component to handle back navigation properly
  const [previousComponent, setPreviousComponent] = React.useState(null);
  
  // Clear session storage when component mounts to avoid stale data issues
  useEffect(() => {
    // Clear invitation-related session storage when starting a new invitation
    sessionStorage.removeItem('profileState');
    sessionStorage.removeItem('brandState');
    sessionStorage.removeItem('cdmoState');
  }, []);
  
  // Update previousComponent whenever showComponent changes
  useEffect(() => {
    setPreviousComponent(showComponent);
  }, [showComponent]);


  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",
        Opacity: 1,
        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  const displayComponent = () => {
    switch (showComponent) {
      case "Profile":
        return (
          <Profile
            setInviteDrawer={setInviteDrawer}
            setShowComponent={setShowComponent}
            profileData={profileData}
            setProfileData={setProfileData}
            departmentDetails={departmentDetails}
          />
        );
      case "Brand":
        return (
          <Brand 
            brandData={brandData} 
            setBrandData={setBrandData} 
            setShowComponent={setShowComponent} 
            profileData={profileData}
          />
        );
      case "CDMO":
        return (
          <CDMO 
            brandData={brandData} 
            setBrandData={setBrandData} 
            setShowComponent={setShowComponent} 
            profileData={profileData} 
          />
        );
      case "InvitationSentScreen":
        return (
          <InvitationSentScreen
            setInviteDrawer={setInviteDrawer}
            profileData={profileData}
            handleRefresh={handleRefresh}
          />
        );
      default:
        return null;
    }
  };
  return (
    <Container style={{ minHeight: "100%" }}>
      <Typography
        style={{ marginTop: "10px", fontSize: "16px", fontWeight: 500 }}
        gutterBottom
      >
        Invite Team Member
      </Typography>
      <Divider style={{ height: "2px", backgroundColor: "black" }} />
      {!departmentDetails
        ? displayError
        : departmentDetails.length === 0
          ? displayNoRecordsFound
          : displayComponent()}
    </Container>
  );
}
